"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportNotificationCtrl = void 0;
class ExportNotificationCtrl {
    constructor(notifications) {
        this.collections = {};
        const notificationsWithErrors = this.getNotificationsWithErrors(notifications || []);
        this.errors = notificationsWithErrors.length > 0;
        if (this.errors) {
            this.notifications = notificationsWithErrors;
        }
        else {
            this.notifications = this.getNotificationsWithWarnings(notifications || []);
        }
    }
    getNotificationsWithErrors(notifications) {
        return notifications.filter((notification) => notification.errors.length > 0);
    }
    getNotificationsWithWarnings(notifications) {
        return notifications.filter((notification) => notification.warnings.length > 0);
    }
    getRevisions() {
        return this.notifications.map((notification) => notification.revision);
    }
    setCollections(collections) {
        this.collections = collections.reduce((map, collection) => {
            map[collection.revision] = collection;
            return map;
        }, {});
    }
    getCollection(revision) {
        return this.collections[revision];
    }
    getTitleFieldName(revision) {
        return this.getCollection(revision).schema.titleField.displayName;
    }
}
exports.ExportNotificationCtrl = ExportNotificationCtrl;
//# sourceMappingURL=export.notification.ctrl.js.map